<template lang="html">
  <div class="w-full">
    <div class="mb-2 pb-2 border-b" >
      <small class="text-xs w-full block"> {{$attrs.email}} </small>
      <small class="text-xs w-full block"> <b> {{$attrs.hero}} </b> <span v-if="$attrs.hero"> | </span> {{$attrs.role}}</small>
    </div>
  </div>
</template>

<script>
  export default {
  }
</script>

<style lang="css">
</style>
